import axios from "axios";
import Vue from 'vue'
import store from './store/index.js';

const envURL = process.env.MIX_APP_URL
const devInstance = createInstance(envURL ? envURL : "http://machshipsync.local/");
const productionInstance = createInstance("http://localhost:3000"); // will change later

function createInstance(baseURL) {
    let jwtToken = '';
    try {
        jwtToken = localStorage.getItem('jwt');
    } catch (error) {

    }
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
        }
    });

    instance.interceptors.request.use(
        (config) => {
            const token = store.getters.getUser.token;
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return instance;
}

export default {
    install() {
        Vue.prototype.$http = devInstance
    }
};